// extracted by mini-css-extract-plugin
export default {"root":"root__1127f854"};